import { AccountType } from '../interface/AccountType';

// 'user' is the canonical Firestore value for family/parent accounts (matches mobile).
// All records include 'user' as a mirror of 'family' so lookups work regardless of which is stored.

export const AccountPageTitles: Record<AccountType, string> = {
  host: 'Host Information',
  coach: 'Account Information',
  family: 'Family Information',
  user: 'Family Information',
};

export const AccountDescriptions: Record<AccountType, string> = {
  host: 'The host is the the point of contact for all of your camp programs.',
  coach: 'Your coach account information is visible to camp hosts and families you work with.',
  family: 'The parent\'s personal information is visible to camp coaches upon registration.',
  user: 'The parent\'s personal information is visible to camp coaches upon registration.',
};

export const MembersSectionTitles: Record<AccountType, string> = {
  host: 'Coaches',
  coach: '',
  family: 'Family Members',
  user: 'Family Members',
};

export const MembersSectionSubtitles: Record<AccountType, string> = {
  host: 'Manage coach profiles for your camp programs',
  coach: '',
  family: 'Manage children profiles for camp registrations',
  user: 'Manage children profiles for camp registrations',
};

export const AddButtonTexts: Record<AccountType, string> = {
  host: 'Add Coach',
  coach: '',
  family: 'Add Child',
  user: 'Add Child',
};

export const EmptyStateByAccount: Record<AccountType, { icon: 'account-tie' | 'account-child'; title: string; text: string; buttonText?: string; }> = {
  host: {
    icon: 'account-tie',
    title: 'No Coaches Added Yet',
    text: 'Add coach profiles to manage your camp programs and sessions',
  },
  coach: {
    icon: 'account-tie',
    title: '',
    text: '',
  },
  family: {
    icon: 'account-child',
    title: 'No Children Added Yet',
    text: 'Add your children\'s profiles to manage their camp registrations and preferences',
    buttonText: 'Add First Child',
  },
  user: {
    icon: 'account-child',
    title: 'No Children Added Yet',
    text: 'Add your children\'s profiles to manage their camp registrations and preferences',
    buttonText: 'Add First Child',
  },
};


